import styled from '@emotion/styled'
import Breakpoint from '../../Breakpoint'

interface TitleProps {
    children: React.ReactNode
    id?: string
    dataCy?: string
    className?: string
    style?: React.CSSProperties
}

const StyledTitle = styled.div`
    font-size: 2.6rem;
    font-family: 'Roboto Semi Bold';
    color: var(--primary-color);
    margin-bottom: 24px;

    @media (max-width: ${Breakpoint.TABLET_L}) {
        width: 100%;
        text-align: center;
    }
`

const Title: React.FC<TitleProps> = ({ children, id, dataCy, className, style }) => {
    return (
        <StyledTitle id={id} data-cy={dataCy} className={className} style={style}>
            {children}
        </StyledTitle>
    )
}

export default Title
